<template>
    <a-locale-provider :locale="zh_CN">
        <!--        <div id="app" class="loading">-->
        <!--            <router-view/>-->
        <!--        </div>-->
        <div id="app">
            <router-view/>
        </div>
    </a-locale-provider>
</template>

<script>
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN'

export default {
    name: 'app',
    data() {
        return {
            zh_CN,
        }
    },
    mounted: function () {
        let ele = document.getElementById('app')
        setTimeout(function () {
            ele.classList.remove('loading')
        }, 1500)
    },
    components: {}
}
</script>

<style>
#app {
    /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
    /*-webkit-font-smoothing: antialiased;*/
    /*-moz-osx-font-smoothing: grayscale;*/
    background-color: #F5F6F9;
}

.loading:before {
    content: '';
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background-color: #1088e9;
    background-image: url("./assets/loading.gif");
    background-size: 10% auto;
    background-position: center;
    background-repeat: no-repeat;
    z-index: 99999999;
}

</style>
